/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_Prereq_TitleInputs */

const en_directory_mcp_prereq_title = /** @type {(inputs: Directory_Mcp_Prereq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before you connect`)
};

const zh_directory_mcp_prereq_title = /** @type {(inputs: Directory_Mcp_Prereq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接之前`)
};

/**
* | output |
* | --- |
* | "Before you connect" |
*
* @param {Directory_Mcp_Prereq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_prereq_title = /** @type {((inputs?: Directory_Mcp_Prereq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_Prereq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_prereq_title(inputs)
	return zh_directory_mcp_prereq_title(inputs)
});
export { directory_mcp_prereq_title as "directory.mcp.prereq_title" }